"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var _hasStoreAdditionalFunctionalities = _interopRequireDefault(require("@deosite/helpers/hasStoreAdditionalFunctionalities"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  showShipping: true,
  vatLabel: false,
  isMinicart: false,
  productsDiscountsSummary: 0,
  fontSet: {
    xs: "xs",
    body: "body2",
    bold: "l"
  }
};
var OrderSummary = function OrderSummary(props) {
  var shipping = props.shipping,
    subtotal = props.subtotal,
    discounts = props.discounts,
    tax = props.tax,
    total = props.total,
    shippingDestination = props.shippingDestination,
    ePremia = props.ePremia,
    _props$showShipping = props.showShipping,
    showShipping = _props$showShipping === void 0 ? defaultProps.showShipping : _props$showShipping,
    _props$vatLabel = props.vatLabel,
    vatLabel = _props$vatLabel === void 0 ? defaultProps.vatLabel : _props$vatLabel,
    _props$isMinicart = props.isMinicart,
    isMinicart = _props$isMinicart === void 0 ? defaultProps.isMinicart : _props$isMinicart,
    _props$productsDiscou = props.productsDiscountsSummary,
    productsDiscountsSummary = _props$productsDiscou === void 0 ? defaultProps.productsDiscountsSummary : _props$productsDiscou,
    summaryButton = props.summaryButton,
    _props$fontSet = props.fontSet,
    fontSet = _props$fontSet === void 0 ? defaultProps.fontSet : _props$fontSet;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var translations = {
    shipping: (0, _langLibrary["default"])("Shipping"),
    subtotal: (0, _langLibrary["default"])("Subtotal"),
    discounts: (0, _langLibrary["default"])("Discounts"),
    tax: (0, _langLibrary["default"])("Tax included"),
    estimateInfo: (0, _langLibrary["default"])("Tax and Shipping are estimated for "),
    total: (0, _langLibrary["default"])("Total"),
    ePremia: (0, _langLibrary["default"])("ePoints discount"),
    withVat: (0, _langLibrary["default"])("with VAT"),
    totalWithTax: (0, _langLibrary["default"])("Total with tax")
  };
  var rowStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "baseline",
    mb: "s7"
  };
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      my: "s10",
      font: fontSet.body,
      color: "main"
    }
  }, showShipping && typeof shipping === "number" && __jsx(_Box["default"], {
    sx: rowStyle,
    "data-test": "shipping-cost-checkout"
  }, __jsx(_Box["default"], null, translations.shipping), __jsx(_Box["default"], null, isNaN(shipping) ? shipping : priceWithCurrency(shipping))), subtotal && __jsx(_Box["default"], {
    sx: rowStyle,
    "data-test": "subtotal-checkout"
  }, __jsx(_Box["default"], null, translations.subtotal), __jsx(_Box["default"], null, priceWithCurrency(subtotal))), (discounts < 0 || productsDiscountsSummary > 0) && __jsx(_Box["default"], {
    sx: rowStyle
  }, __jsx(_Box["default"], null, translations.discounts), __jsx(_Box["default"], {
    sx: {
      color: "active"
    }
  }, discounts < 0 ? productsDiscountsSummary === 0 ? priceWithCurrency(discounts) : priceWithCurrency(discounts - productsDiscountsSummary) : priceWithCurrency(-productsDiscountsSummary))), ePremia < 0 && global.__appConfig__.epointsVisible === 1 && __jsx(_Box["default"], {
    sx: rowStyle
  }, __jsx(_Box["default"], null, translations.ePremia), __jsx(_Box["default"], {
    sx: {
      color: "orange"
    }
  }, priceWithCurrency(ePremia))), shippingDestination && __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, rowStyle), {}, {
      color: "neutral700",
      font: fontSet.xs
    })
  }, __jsx(_Box["default"], {
    sx: {
      flexBasis: "70%"
    }
  }, translations.estimateInfo, " ", shippingDestination)), __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, rowStyle), {}, {
      mb: "s0",
      font: fontSet.bold,
      color: "main"
    })
  }, isMinicart && (0, _hasStoreAdditionalFunctionalities["default"])(language) ? __jsx(_Box["default"], {
    sx: {
      color: "negative"
    }
  }, translations.totalWithTax) : __jsx(_Box["default"], null, translations.total), __jsx(_Box["default"], null, priceWithCurrency(total), " ", (0, _hasStoreAdditionalFunctionalities["default"])(language) && vatLabel && __jsx(_Box["default"], {
    as: "p",
    sx: {
      color: "neutral700",
      font: fontSet.xs
    }
  }, translations.withVat))), tax > 0 && (0, _hasStoreAdditionalFunctionalities["default"])(language) && __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, rowStyle), {}, {
      color: "neutral700",
      font: fontSet.xs
    })
  }, __jsx(_Box["default"], {
    sx: {
      flexBasis: "70%"
    }
  }, translations.tax), __jsx(_Box["default"], null, priceWithCurrency(tax))), (0, _hasStoreAdditionalFunctionalities["default"])(language) && summaryButton && __jsx(_Box["default"], {
    sx: {
      marginTop: "s8"
    }
  }, summaryButton));
};
var _default = OrderSummary;
exports["default"] = _default;